import React, { useEffect, useState } from 'react';
import { getPageComponents } from '../../../../common/utils/page_utils';
import { FieldTypes } from 'drapcode-constant';

export const MappingRow = ({ row, pageContent, collection, collections, createNewParamRow }) => {
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const [refCollectionName, setRefCollectionName] = useState('');
  const [refField, setRefField] = useState('');
  const [isRefField, setIsRefField] = useState(false);

  const collectionFieldsOptions = (collectionName, showRefFieldType = false) => {
    let options = [];
    const selectedCollection = collections.find((e) => e.collectionName === collectionName);
    let selectedFields = selectedCollection ? selectedCollection.fields : [];
    options = selectedFields.map((e) => ({
      value: e.fieldName,
      label: `${e.fieldTitle.en} ${
        showRefFieldType && FieldTypes.reference.id === e.type ? '(Reference)' : ''
      }`,
      type: e.type,
      refCollection: e.refCollection ? e.refCollection : '',
    }));
    return options;
  };

  const fieldsOptions = collectionFieldsOptions(collection, true);
  const refFieldOptions = collectionFieldsOptions(refCollectionName);
  const pageComponentOptions = getPageComponents(pageContent, [
    'header',
    'text',
    'paragraph',
    'select',
    'input',
    'textarea',
    'checkbox',
  ]);

  const onKeyChange = (value) => {
    setKey(value);
    row['key'] = value;
    const fieldsOption = fieldsOptions.find((opt) => opt.value === value);
    if (fieldsOption) {
      row['type'] = fieldsOption.type;
      if (FieldTypes.reference.id === fieldsOption.type && fieldsOption.refCollection) {
        setRefCollectionName(fieldsOption.refCollection.collectionName);
        setIsRefField(true);
      }
    }
    createNewParamRow(row);
  };

  const onValueChange = (value) => {
    setValue(value);
    row['value'] = value;
    createNewParamRow(row);
  };

  const onRefFieldChange = (value) => {
    if (value) {
      setRefField(value);
      row['refField'] = value;
      createNewParamRow(row);
    }
  };

  useEffect(() => {
    setKey(row.key);
    setValue(row.value);
    setRefField(row.refField);

    const fieldsOption = fieldsOptions.find((opt) => opt.value === row.key);
    if (
      fieldsOption &&
      FieldTypes.reference.id === fieldsOption.type &&
      fieldsOption.refCollection
    ) {
      setRefCollectionName(fieldsOption.refCollection.collectionName);
      setIsRefField(true);
    } else {
      setIsRefField(false);
    }
  }, [row.key, row.value, row.refField, collection]);

  return (
    <tr className="col-md-12 col-lg-12">
      <td className="col-md-6 col-lg-6">
        <div className="row">
          <div className={isRefField ? `col-md-6 col-lg-6 pr-1` : 'col-md-12 col-lg-12'}>
            <select
              name="key"
              onChange={(e) => onKeyChange(e.target.value)}
              className="form-control form-control-sm custom-select-sm"
              value={key}
            >
              <option value="">- Select One -</option>
              {fieldsOptions.map((e) => (
                <option key={e.value} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
          </div>
          {isRefField && (
            <div className="col-md-6 col-lg-6 pl-1">
              <select
                name="refField"
                onChange={(e) => onRefFieldChange(e.target.value)}
                className="form-control form-control-sm custom-select-sm"
                value={refField}
              >
                <option value="">- Select One -</option>
                {refFieldOptions.map((e) => (
                  <option key={e.value} value={e.value}>
                    {e.label}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </td>
      <td className="col-md-6 col-lg-6">
        <select
          name="value"
          onChange={(e) => onValueChange(e.target.value)}
          className="form-control form-control-sm custom-select-sm"
          value={value}
        >
          <option value="">- Select One -</option>
          {pageComponentOptions.map((e) => (
            <option key={e.value} value={e.value}>
              {e.label}
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
};
